export default __webpack_public_path__ + "static/people-1-804ff7faa8101fe16bd6510976363505.jpg";